import React from "react";

import {
  WSActions,
  WSElement,
  WSPillTheme,
  WSSectionToolbar,
  WSTable,
  WSTableCell
} from "@wingspanhq/fe-component-library";
import { IconType } from "@wingspanhq/fe-component-library/dist/lib/components/common/WSPill/types";
import queryString from "qs";
import { useHistory } from "react-router-dom";
import { InvoiceRow, InvoiceStatus } from "@wingspanhq/wingspan-api-sdk";
import { queriesInvoiceRows } from "@query";
import { WSQueries } from "../../../../query/WSQuery";

type RecentInvoicesWidgetProps = {
  payerId: string;
};

export const RecentInvoicesWidget: React.FC<RecentInvoicesWidgetProps> = ({
  payerId
}) => {
  const history = useHistory();

  const queryInvoicesRows = queriesInvoiceRows.searchInvoiceRows.useQuery({
    filter: {
      payerId: { eq: payerId }
    },
    page: {
      size: 5
    }
  });

  return (
    <WSQueries
      queries={{ queryInvoicesRows }}
      renderErrors={() => null}
      renderLoader={() => null}
    >
      {({ queryInvoicesRowsData }) => {
        const invoices = queryInvoicesRowsData.data ?? [];

        if (!invoices.length) {
          return null;
        }

        return (
          <WSElement>
            <WSSectionToolbar title="Recent invoices" mb="S" />

            <WSTable<InvoiceRow>
              tableData={invoices.map(invoice => ({
                id: invoice.id ?? "",
                data: invoice
              }))}
              onRowClick={row => {
                history.push(`/member/invoices/${row.id}`);
              }}
              columns={[
                {
                  config: {
                    header: {
                      text: "Invoice #"
                    },
                    gridTemplateSizeMax: "2fr"
                  },
                  renderFunction: ({ data }) => {
                    // const engagement = engagements.find(
                    //   e => e.payerPayeeEngagementId === data.memberClientId
                    // );

                    return (
                      <WSTableCell
                        text={`#${data.invoiceNumber ?? "Pending"}`}
                        // secondaryText={
                        //   engagement
                        //     ? getTmpEngagementName(engagement)
                        //     : undefined
                        // }
                      />
                    );
                  }
                },
                {
                  config: {
                    header: {
                      text: "Status"
                    }
                  },
                  renderFunction: ({ data }) => {
                    let icon: IconType<any> = "time";
                    let theme: WSPillTheme = "neutral";
                    let badge: boolean = false;

                    const status = data.status;

                    if (
                      status === InvoiceStatus.OPENED ||
                      status === InvoiceStatus.OVERDUE
                    ) {
                      icon = "calendar";
                    } else if (
                      status === InvoiceStatus.PENDING ||
                      status === InvoiceStatus.DISPUTED ||
                      status === InvoiceStatus.RETURNED
                    ) {
                      icon = "alert";
                      theme = "warning";
                      badge = true;
                    } else if (
                      status === InvoiceStatus.PAID ||
                      status === InvoiceStatus.PARTIALLY_PAID ||
                      status === InvoiceStatus.PAID_OFF_PLATFORM
                    ) {
                      icon = true;
                      theme = "success";
                    } else if (status === InvoiceStatus.PAYMENT_IN_TRANSIT) {
                      icon = "check";
                    } else {
                      icon = "edit";
                    }

                    return (
                      <WSTableCell
                        pill={
                          badge
                            ? {
                                badge,
                                theme,
                                icon
                              }
                            : {
                                theme,
                                icon
                              }
                        }
                      />
                    );
                  }
                }
              ]}
            />
            <WSActions
              alignment="left"
              size="M"
              mt="M"
              buttons={[
                {
                  label: "View all in invoices page",
                  kind: "Link",
                  onClick: () => {
                    const query = queryString.stringify({
                      clientId: payerId
                    });
                    history.push(`/member/invoices?${query}`);
                  }
                }
              ]}
            />
          </WSElement>
        );
      }}
    </WSQueries>
  );
};
